import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RecordingButton from 'shared/browser_audio_player/views/RecordingButton';

class TtsPromptPlayButton extends Component {
  constructor(props) {
    super(props);
    var promptAttrs = this._getPromptAttrs();
    // eslint-disable-next-line new-cap
    this.recordingModel = new this.props.recordingModelClass({
      recordId: promptAttrs.promptText,
      recordTitle: 'Prompt',
      recordingUrl: promptAttrs.promptUrl,
      url: this.props.promptUrlApiEndpoint,
      downloadUrl: promptAttrs.promptUrl
    });
    this.props.recordingCollection.add(this.recordingModel);
    this.recordingModel.on('beforePlay', this._beforePlay, this);
    this.recordingModel.on('change:play', this._onChangePlay, this);
  }

  _getPromptAttrs() {
    var promptText = this.props.promptInput.val();
    return {
      promptText: this._normalizeText(promptText),
      promptUrl: this._getExistingPromptUrl(promptText)
    };
  }

  _normalizeText(text) {
    return text.replace(/^\s+|\s+$/g, '').replace(/\s+/g, " ");
  }

  _getExistingPromptUrl(promptText) {
    var prompt;
    if (this.props.promptUrls) {
      var normalizedText = this._normalizeText(promptText);
      for (var listIndex = 0; listIndex < this.props.promptUrls.length; ++listIndex) {
        if (this._normalizeText(this.props.promptUrls[listIndex].prompt) === normalizedText) {
          prompt = this.props.promptUrls[listIndex];
          break;
        }
      }
    }
    return prompt ? prompt.url : prompt;
  }

  _beforePlay() {
    var promptAttrs = this._getPromptAttrs();
    if (promptAttrs.promptText !== this.recordingModel.get('recordId')) {
      this.recordingModel.set({ recordId: promptAttrs.promptText, recordingUrl: promptAttrs.promptUrl, downloadUrl: promptAttrs.promptUrl });
    }
  }

  _onChangePlay() {
    if (this.props.onPlayStarted && this.recordingModel.get('play') && !this.recordingModel.get('audioProgress')) {
      this.props.onPlayStarted();
    }
  }

  render() {
    return <RecordingButton model={this.recordingModel} />;
  }
}

TtsPromptPlayButton.propTypes = {
  promptInput: PropTypes.object.isRequired,
  promptUrls: PropTypes.array,
  promptUrlApiEndpoint: PropTypes.string.isRequired,
  recordingCollection: PropTypes.object.isRequired,
  recordingModelClass: PropTypes.func.isRequired,
  onPlayStarted: PropTypes.func
};

export default TtsPromptPlayButton;
